<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">
    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <!-- Sign In Form Column -->
      <a-col
        :span="24"
        :md="12"
        :lg="{ span: 12, offset: 0 }"
        :xl="{ span: 6, offset: 2 }"
        class="col-form"
      >
        <h1 class="mb-15">登录</h1>
        <h5 class="font-regular text-muted">输入用户名/手机号和密码进行登录</h5>

        <!-- Sign In Form -->
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          ref="loginForm"
          :hideRequiredMark="true"
        >
          <a-form-item class="mb-10" label="用户名/手机号" :colon="false">
            <a-input
              v-decorator="[
                'userName',
                {
                  rules: [{ required: true, message: '请输入用户名或手机号!' }],
                },
              ]"
              placeholder="用户名/手机号"
            />
          </a-form-item>
          <a-form-item class="mb-5" label="密码" :colon="false">
            <a-input
              v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入密码！' }] },
              ]"
              type="password"
              placeholder="密码"
            />
          </a-form-item>

          <a-form-item>
            <a-button
              type="primary"
              block
              html-type="submit"
              class="login-form-button"
              @click.native.prevent="handleLogin"
            >
              登 录
            </a-button>
          </a-form-item>
        </a-form>
        <!-- / Sign In Form -->
      </a-col>
      <!-- / Sign In Form Column -->

      <!-- Sign In Image Column -->
      <a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
        <img src="images/img-signin.jpg" alt="" />
      </a-col>
      <!-- Sign In Image Column -->
    </a-row>
  </div>
</template>

<script>
import { login } from "@/api/login";

export default {
  data() {
    return {
      // Binded model property for "Sign In Form" switch button for "Remember Me" .
      redirect: "",
    };
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // Handles input validation after submission.
    handleLogin() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store
            .dispatch("user/login", values)
            .then(() => {
              this.$router.push({ path: this.redirect || "/" });
            })
            .catch(() => {});
        } else {
          this.$message.error(res.message);
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #ffffff;
}
</style>